import React, { useEffect, useState } from "react";
import BackClick from "../components/BackClick";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import { apiBaseUrl } from "../config";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { getList } from "../reducer/productListSlice";
import ProductsMapList from "../components/ProductsMapList";
import Loader from "../components/loader/Loader";
import CommonDrawer from "../components/drawer/CommonDrawer";
import { BsGrid } from "react-icons/bs";
import { CiGrid2H } from "react-icons/ci";
import FilterListIcon from "@mui/icons-material/FilterList";
import SingleOne from "../components/SingleOne";
import ViewCartButton from "../components/ViewCartButton";
import HeaderSection from "../components/HeaderSection/HeaderSection";
import BreadCrums from "../components/Breadcrums/BreadCrums";
import HeaderSlider from "../components/Header-Slider/HeaderSlider";
import ProductFilter from "../components/ProductFilter/ProductFilter";
import { useUser } from "../context/userContext";
import { getDomainInfo } from "../utils/utils";
import Footer from "../components/Footer/Footer";

function CollectionDetails() {
  const location = useLocation();
  console.log("location details", location?.state?.collectionDetails);
  const [collectionDetail, setCollectionDetail] = useState(
    location.state?.collectionDetails || null
  );
  const [products, setProducts] = useState([]);
  const [title, setTitle] = useState();
  const [totalProductLength, setTotalProductLength] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [isGridView, setIsGridView] = useState(true);
  const [subcategoryIds, setSubCategoryIds] = useState([]);
  const [categoryIds, setCategoryIds] = useState([]);
  const [showMenu, setShowMenu] = useState(false);
  const [isFilterFullScreen, setFilterFullScreen] = useState(false);
  const [activeFilters, setActiveFilters] = useState({});
  const [filterableProducts, setFilterableProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [visibleProducts, setVisibleProducts] = useState(10);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const productList = useSelector((state) => state.productslst?.products);
  const customSort = useSelector((state) => state.fetchUser?.user?.customSort);
  const cart =
    useSelector((state) => state.fetchCart?.cartInfo?.cartItem) || [];
  const subCategory = useSelector((state) => state.category?.subCategoryList);
  const { userId } = useParams();
  console.log("userId from useParams:", userId);
  const { uid } = getDomainInfo(userId);
  console.log("UID from getDomainInfo:", uid);
  const { userData, fetchUserData } = useUser();

  const sid = userData?.id;
  console.log("data from the user", sid);

  const userid = useSelector((state) => state.fetchUser?.user?.id);
  console.log("redux data", userid);

  const [cartLength, setCartLength] = useState(0);

  useEffect(() => {
    if (uid) {
      fetchUserData(uid);
      console.log("Fetching user data for UID:", uid);
    } else {
      console.error("UID is undefined, skipping fetchUserData.");
    }
  }, [uid]);

  // Add new useEffect to handle collection details fetching
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const stateDetails = location?.state?.collectionDetails;
        if (stateDetails?.isRecentViewed && Array.isArray(stateDetails.products)) {
          const enrichedProducts = stateDetails.products.map((item) => ({
            ...item,
            id: item.id || item._id,
            price: item.price || 0,
            mrp: item.mrp || 0,
            title: item.title || "",
            image: item.image || "",
            description: item.description || "",
            stock: item.stock || 0,
          }));

          setCollectionDetail(stateDetails);
          setTitle(stateDetails.title);
          dispatch(getList(enrichedProducts));
          setTotalProductLength(enrichedProducts.length);
          return;
        }
        if (stateDetails?.productIds) {
          setCollectionDetail(stateDetails);
          setTitle(stateDetails.title);
          await fetchProductDetails(stateDetails.productIds);
          return;
        }
        await fetchCollectionDetails();

      } catch (error) {
        console.error("Error fetching collection data:", error);
        setTitle("Collection Not Found");
        dispatch(getList([]));
      } finally {
        setLoading(false);
      }
    };

    if (sid) {
      fetchData();
    }
  }, [sid, location?.state?.collectionDetails]);

  const handleOpenDrawer = (product) => {
    setSelectedProduct(product);
    setDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setSelectedProduct(null);
  };

  const toggleGridView = () => {
    setIsGridView((prev) => !prev);
  };

  const fetchProductList = async () => {
    try {
      const response = await axios.post(
        `${apiBaseUrl}user/filter-seller-products/${sid}`,
        { subcategoryIds, customSort }
      );
      if (response) {
        dispatch(getList(response?.data?.products));
        setTotalProductLength(response?.data?.products?.length);
      }
    } catch (error) {
      console.error("Error fetching Products:", error);
    }
  };

  function handleFilter() {
    fetchProductList();
  }

  function handleSubCategoryIdAdd(e, id) {
    if (e.target.checked) {
      setSubCategoryIds([...subcategoryIds, id]);
    } else {
      setSubCategoryIds(subcategoryIds.filter((item) => item !== id));
    }
  }

  useEffect(() => {
    if (categoryIds.length === 0) {
      setSubCategoryIds([]);
    }
  }, [categoryIds]);

  const fetchProductDetails = async (productIds) => {
    try {
      if (!sid || !Array.isArray(productIds) || productIds.length === 0) return;

      const productIdsArray = productIds.map((product) => product.product);
      const payload = { productIds: productIdsArray, customSort };

      const response = await axios.post(
        `${apiBaseUrl}user/get-product-details/${sid}`,
        payload
      );

      if (response?.data?.products?.length > 0) {
        dispatch(getList(response.data.products));
        setTotalProductLength(response.data.products.length);
      }
    } catch (error) {
      console.error("Error fetching product details:", error);
    } finally {
      setLoading(false);
    }
  };

  const updateCartLength = () => {
    setCartLength(cart.filter((item) => item.storeid === sid).length);
  };

  useEffect(() => {
    updateCartLength();
  }, [cart]);

  const { collectionName } = useParams();

  const fetchCollectionDetails = async () => {
    try {
      setLoading(true);
      const decodedCollectionName = decodeURIComponent(collectionName);
      const response = await axios.get(
        `${apiBaseUrl}user/get-seller-collections-details/${sid}?title=${decodedCollectionName}`
      );

      if (response.status === 200 && response.data?.success) {
        if (response.data.sellerCollections?.length > 0) {
          const collection = response.data.sellerCollections[0];
          setCollectionDetail(collection);
          setTitle(collection.title);
          const formattedProducts = collection.productIds.map((item) => ({
            ...item.product,
            id: item.product._id,
            images: item.product.images || [],
            price: Number(item.product.price) || 0,
            mrp: Number(item.product.mrp) || 0,
            title: item.product.title || "",
            description: item.product.description || "",
            stock: Number(item.product.stock) || 0,
          }));

          dispatch(getList(formattedProducts));
          setTotalProductLength(formattedProducts.length);
        } else {
          setTitle("Collection Not Found");
          dispatch(getList([]));
          setTotalProductLength(0);
        }
      }
    } catch (error) {
      console.error("Error fetching collection details:", error);
      setTitle("Collection Not Found");
      dispatch(getList([]));
      setTotalProductLength(0);
    } finally {
      setLoading(false);
    }
  };

  const openFilterWithData = async () => {
    try {
      const res = await axios.post(`${apiBaseUrl}user/filter-seller-products-by-category/${sid}`);
      if (res.data.success) {
        const enrichedProducts = res.data.products.map((p) => ({
          ...p,
          price: p.price || 0,
          additionalInfo: {
            variantGroups: p.additionalInfo?.variantGroups || [],
            attributeGroups: p.additionalInfo?.attributeGroups || [],
          },
        }));
        setFilterableProducts(enrichedProducts);
        setFilterFullScreen(true);
      }
    } catch (err) {
      console.error("Failed to fetch filter data", err);
    }
  };

  const handleFilterApply = ({ filteredProducts, filters }) => {
    setFilteredProducts(filteredProducts);
    setActiveFilters(filters);
    setIsFilterApplied(true);
    setFilterFullScreen(false);
    setVisibleProducts(10);
  };

  const clearFilters = () => {
    setFilteredProducts([]);
    setActiveFilters({});
    setIsFilterApplied(false);
  };

  return (
    <>
    <div className="order-status-sec rootCommonBox collection-listing-sec">
                    <div className="customCardBox" style={{background:'#eee' }}>
      <BackClick/>
      <div className="view-more-container">
        {loading ? (
          <Loader />
        ) : productList?.length === 0 ? (
          <h5 className="text-center d-block w-100 mt-5">No Record Present</h5>
        ) : (
          <>
            <div className="collection-title">
              <h4>{title}</h4>
              <BreadCrums title={title} />
            </div>
            <div className="header-section">
              <h3>{isFilterApplied ? filteredProducts.length : totalProductLength}{" "}products found</h3>
              <div className="icons">
                <button onClick={toggleGridView}className="icon-button primary-font-color row-column-item-btn">
                  {isGridView ?  <CiGrid2H />: <BsGrid />}
                </button>
                <span>|</span>
                <button className="icon-button primary-font-color filter-btn" onClick={openFilterWithData}>
                  {/* <img src="/Images/Icons/filter.png" alt="filter" /> */}
                  <svg width="20" height="16" viewBox="0 0 20 16" fill="none"  xmlns="http://www.w3.org/2000/svg"><path d="M12.6562 0.5C13.2422 0.5 13.75 1.00781 13.75 1.59375C13.75 1.86719 13.6328 2.10156 13.4766 2.29688L9.375 6.98438V14.5625C9.375 15.1094 8.94531 15.5 8.39844 15.5C8.20312 15.5 8.00781 15.4609 7.8125 15.3438L4.84375 13.0781C4.53125 12.8438 4.375 12.4922 4.375 12.0625V6.98438L0.234375 2.29688C0.078125 2.10156 0 1.86719 0 1.59375C0 1.00781 0.46875 0.5 1.05469 0.5H12.6562ZM5.625 6.75V12.0625L8.125 13.9766V6.75C8.125 6.63281 8.16406 6.47656 8.24219 6.35938L12.2656 1.75H1.44531L5.46875 6.35938C5.54688 6.47656 5.58594 6.63281 5.58594 6.75H5.625ZM19.375 13.625C19.6875 13.625 20 13.9375 20 14.25C20 14.6016 19.6875 14.875 19.375 14.875H13.125C12.7734 14.875 12.5 14.6016 12.5 14.25C12.5 13.9375 12.7734 13.625 13.125 13.625H19.375ZM12.5 8C12.5 7.6875 12.7734 7.375 13.125 7.375H19.375C19.6875 7.375 20 7.6875 20 8C20 8.35156 19.6875 8.625 19.375 8.625H13.125C12.7734 8.625 12.5 8.35156 12.5 8ZM19.375 1.125C19.6875 1.125 20 1.4375 20 1.75C20 2.10156 19.6875 2.375 19.375 2.375H15.625C15.2734 2.375 15 2.10156 15 1.75C15 1.4375 15.2734 1.125 15.625 1.125H19.375Z" fill="currentcolor"/></svg>
                </button>
              </div> 
            </div>

            <div className="d-flex justify-content-between ProductItemContainer"style={{ paddingBottom: "62px" }}>
              {isGridView ? (
                <ProductsMapList
                  productList={isFilterApplied ? filteredProducts : productList}
                  handleOpenDrawer={handleOpenDrawer}
                />
              ) : (
                <SingleOne
                  productList={
                    isFilterApplied
                      ? filteredProducts.slice(0, visibleProducts)
                      : productList.slice(0, visibleProducts)
                  }
                  handleOpenDrawer={handleOpenDrawer}
                />
              )}
            </div>

            <CommonDrawer isOpen={isDrawerOpen} onClose={handleCloseDrawer} product={selectedProduct}/>

            {/* <div className="hello-store-brn" id="hello-store-brn">
              <h6>View Full Catalogue</h6>
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path
                  d="M9.09066 4.67545C10.3817 4.67545 11.4284 3.62882 11.4284 2.33773C11.4284 1.04664 10.3817 0 9.09066 0C7.79956 0 6.75293 1.04664 6.75293 2.33773C6.75293 3.62882 7.79956 4.67545 9.09066 4.67545Z"
                  fill="white"
                />
                <path
                  d="M2.33773 4.67545C3.62882 4.67545 4.67545 3.62882 4.67545 2.33773C4.67545 1.04664 3.62882 0 2.33773 0C1.04664 0 0 1.04664 0 2.33773C0 3.62882 1.04664 4.67545 2.33773 4.67545Z"
                  fill="white"
                />
                <path
                  d="M9.09066 11.4284C10.3817 11.4284 11.4284 10.3817 11.4284 9.09066C11.4284 7.79956 10.3817 6.75293 9.09066 6.75293C7.79956 6.75293 6.75293 7.79956 6.75293 9.09066C6.75293 10.3817 7.79956 11.4284 9.09066 11.4284Z"
                  fill="white"
                />
                <path
                  d="M2.33773 11.4284C3.62882 11.4284 4.67545 10.3817 4.67545 9.09066C4.67545 7.79956 3.62882 6.75293 2.33773 6.75293C1.04664 6.75293 0 7.79956 0 9.09066C0 10.3817 1.04664 11.4284 2.33773 11.4284Z"
                  fill="white"
                />
              </svg>
            </div> */}
          </>
        )}
          <Footer />
        <div>
          {cart?.filter((item) => item.storeid === sid).length > 0 && (
            <ViewCartButton cartLength={cartLength} />
          )}
        </div>
      </div>

      {isFilterFullScreen && (
        <ProductFilter
          products={filterableProducts}
          initialFilters={activeFilters}
          onApply={handleFilterApply}
          onClose={() => setFilterFullScreen(false)}
        />
      )}
      </div>
      </div>
    </>
  );
}

export default CollectionDetails;